<template>
  <article class="col-lg-12 gp-campaigns">
    <Portal to="headerActions" v-if="closePortal || !fetched">
      <div class="col-12 col-mlg-7 ml-auto mt-1 mt-sm-0">
        <div class="row justify-content-center justify-content-sm-end">
          <button class="btn btn-lg btn-primary typo-button14 typo-medium btn-default" @click="openModal('newCampaign')" :disabled="loading" v-if="reachLimit">
            <span class="mr-1">
              <i class="icon icon-plus typo-icon-12"></i>
            </span>
            <span>{{ $t("analytic.ab.createNewCamp") }}</span>
          </button>
          <button class="btn btn-lg btn-primary typo-button14 typo-medium btn-default disabled" v-else v-popover:tooltip.bottom="$t('analytic.ab.tooltipBtnCreate2')">
            <span class="mr-1">
              <i class="icon icon-lock typo-icon-16"></i>
            </span>
            <span>{{ $t("analytic.ab.createNewCamp") }}</span>
          </button>
          <!-- <ButtonCreateCampaign @click="openModal('newCampaign')" /> -->
        </div>
      </div>
    </Portal>
    <div class="row">
      <div class="col-12 col-md-6">
        <div class="row">
          <GpTabs class="flex-md-grow-0" @tabChange="changeTab" :active="active" :customNav="true">
            <template v-slot:GpTabsNav="{ activeIndex, handler }">
              <GpTabsNav class="d-flex">
                <GpTab class="gp-campaigns-tab" to="#" index="all" :activeIndex="activeIndex" @click="handler">
                  {{ $t("generals.all") }}
                </GpTab>

                <GpTab class="gp-campaigns-tab" to="#" index="on_hold" :activeIndex="activeIndex" @click="handler">
                  {{ $t("analytic.ab.onHold") }}
                </GpTab>

                <GpTab class="gp-campaigns-tab" to="#" index="running" :activeIndex="activeIndex" @click="handler">
                  {{ $t("analytic.ab.running") }}
                </GpTab>

                <GpTab class="gp-campaigns-tab" to="#" index="completed" :activeIndex="activeIndex" @click="handler">
                  {{ $t("analytic.ab.completed") }}
                </GpTab>
              </GpTabsNav>
            </template>
          </GpTabs>
        </div>
      </div>
      <div class="col-12 col-md-6 mt-1 mt-md-0">
        <div class="row">
          <div class="col-6 col-lg-4 align-items-center d-flex justify-content-start justify-content-md-end">
            <FilterSelect v-model="filter" :items="filterOptions" />
          </div>
          <div class="col-6 col-lg-8">
            <div class="row">
              <GpInputSearch v-model="query" @input="resetPaging" :placeholder="$t('analytic.ab.searchCamp')" />
            </div>
          </div>
        </div>
      </div>

      <template v-if="loading">
        <div class="col-12 pl-0">
          <CampaignItem class="mt-3" v-for="i in 5" :key="'loading-campaign-' + i" />
        </div>
      </template>
      <template v-else>
        <!-- <template v-if="!campaigns || !campaigns[activeIndex == 'all' ? 'opens' : activeIndex] || !campaigns[activeIndex == 'all' ? 'opens' : activeIndex].length"> -->
        <template v-if="!campaignList || !campaignList.length">
          <div class="col-12">
            <div class="empty-campaign">
              <h4 class="typo-heading24 typo-semibold text-light-high mb-1">
                {{ $t("empty.campaign.emptyType", { type: campaignTypeText }) }}
              </h4>
              <p class="typo-paragraph14 typo-regular text-light-low mb-3">
                {{ $t("empty.campaign.submit") }}
              </p>
              <button class="btn btn-lg btn-primary typo-button14 typo-medium btn-default" @click="openModal('newCampaign')" v-if="reachLimit">
                <span class="mr-1">
                  <i class="icon icon-plus typo-icon-12"></i>
                </span>
                <span>{{ $t("analytic.ab.createNewCamp") }}</span>
              </button>
              <button class="btn btn-lg btn-primary typo-button14 typo-medium btn-default disabled" v-else v-popover:tooltip.bottom="$t('analytic.ab.tooltipBtnCreate2')">
                <span class="mr-1">
                  <i class="icon icon-lock typo-icon-16"></i>
                </span>
                <span>{{ $t("analytic.ab.createNewCamp") }}</span>
              </button>
            </div>
          </div>
        </template>

        <template v-else>
          <template v-if="filteredList && filteredList.length">
            <section class="col-12 campaign-list">
              <div class="row warning-container py-1 px-2 mt-3" v-if="!reachLimit">
                <div class="col d-flex align-items-center">
                  <div class="row align-items-center">
                    <svg class="mr-1" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g>
                        <path d="M1.73011 17.8312L2.29688 16.0899H5.05238L5.61914 17.8312H7.34925L4.7168 10.1948H2.63619L0 17.8312H1.73011ZM2.70703 14.8296L3.64666 11.9399H3.70632L4.64595 14.8296H2.70703Z" fill="#212121" />
                        <path d="M10.9949 11.7744H9.62646L7.16553 20.9172H8.53396L10.9949 11.7744Z" fill="#212121" />
                        <path d="M10.9951 24.0001H14.2577C15.9729 24.0001 16.8865 23.1052 16.8865 21.8897C16.8865 20.7599 16.0773 20.0775 15.2085 20.0365V19.962C16.0028 19.783 16.5882 19.2199 16.5882 18.3213C16.5882 17.1766 15.738 16.3638 14.0526 16.3638H10.9951V24.0001ZM12.6096 22.6802V20.6518H13.9632C14.7387 20.6518 15.2197 21.0992 15.2197 21.7294C15.2197 22.3036 14.8282 22.6802 13.9259 22.6802H12.6096ZM12.6096 19.5593V17.6688H13.8364C14.5523 17.6688 14.9587 18.038 14.9587 18.5898C14.9587 19.1938 14.4665 19.5593 13.8066 19.5593H12.6096Z" fill="#212121" />
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M17.3257 11.8487C20.1835 11.8487 22.5001 9.5321 22.5001 6.67437C22.5001 3.81665 20.1835 1.5 17.3257 1.5C14.468 1.5 12.1514 3.81665 12.1514 6.67437C12.1514 9.5321 14.468 11.8487 17.3257 11.8487ZM17.3257 13.3487C21.0119 13.3487 24.0001 10.3605 24.0001 6.67437C24.0001 2.98822 21.0119 0 17.3257 0C13.6396 0 10.6514 2.98822 10.6514 6.67437C10.6514 10.3605 13.6396 13.3487 17.3257 13.3487Z" fill="#212121" />
                        <path d="M17.9806 3.18213H16.6746L16.7826 7.4058H17.8692L17.9806 3.18213ZM17.3259 10.1675C17.7241 10.1675 18.065 9.83679 18.0683 9.42509C18.065 9.02014 17.7241 8.68943 17.3259 8.68943C16.9142 8.68943 16.5801 9.02014 16.5835 9.42509C16.5801 9.83679 16.9142 10.1675 17.3259 10.1675Z" fill="#212121" />
                      </g>
                    </svg>
                    <span class="warning-text">{{ $t("analytic.ab.reachMaximum") }}</span>
                  </div>
                </div>
                <div class="col-3 d-flex align-items-center justify-content-end" v-if="permission.analytics">
                  <div class="row align-items-center">
                    <router-link :to="{ name: 'Pricing', query: { from: dynamicTrigger.ab_testing_campaign } }" class="btn btn-primary">
                      <svg class="mr-1" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14.1998 12.2002H1.7998C1.3998 12.2002 1.0998 11.9002 1.0998 11.5002L0.299805 5.30017C0.299805 5.10017 0.299805 4.80016 0.399805 4.60016C0.499805 4.30016 0.799805 4.10016 1.0998 4.00016C1.3998 3.90016 1.6998 3.90016 1.9998 4.10016C1.9998 4.10016 2.0998 4.10016 2.0998 4.20016L4.5998 6.00016L6.9998 2.40017C6.9998 2.30017 7.0998 2.30016 7.1998 2.20016C7.6998 1.80016 8.4998 1.80016 8.8998 2.30016L11.3998 6.00016L13.7998 4.10016L13.8998 4.00016C14.1998 4.00016 14.4998 3.90016 14.6998 4.00016C15.3998 4.10016 15.7998 4.70017 15.6998 5.40017L14.8998 11.6002C14.8998 11.9002 14.4998 12.2002 14.1998 12.2002ZM2.4998 10.7002H13.4998L14.0998 5.80017L12.0998 7.40017C11.5998 7.80017 10.7998 7.70016 10.3998 7.20016C10.3998 7.20016 10.3998 7.10016 10.2998 7.10016L7.9998 3.70016L5.5998 7.10016C5.4998 7.40017 5.1998 7.60016 4.8998 7.60016C4.5998 7.70016 4.2998 7.60016 3.9998 7.40017L1.7998 5.80017L2.4998 10.7002Z" fill="currentColor" />
                        <path d="M14.0996 14.1H1.89961C1.49961 14.1 1.09961 13.8 1.09961 13.3C1.09961 12.8 1.39961 12.5 1.89961 12.5H13.9996C14.3996 12.5 14.7996 12.8 14.7996 13.3C14.7996 13.8 14.4996 14.1 14.0996 14.1Z" fill="currentColor" />
                      </svg>
                      <span>{{ $t("generals.upgrade") }}</span>
                    </router-link>
                  </div>
                </div>
              </div>
              <CampaignItem class="mt-3" v-for="(item, key) in slicedList" :key="key" :item="item" @select="itemClick" />
            </section>
            <section class="col-12">
              <Pagination :paginationParam.sync="paging" :total.sync="paging.total" @page="toPage" />
            </section>
          </template>
          <div class="col-12" v-else>
            <div class="empty-campaign">
              <h4 class="typo-heading24 typo-semibold text-light-high mb-1">
                {{ $t("search.noResult", { keyword: query }) }}
              </h4>
              <p class="typo-paragraph14 typo-regular text-light-low">
                {{ $t("search.tryAnother") }}
              </p>
            </div>
          </div>
        </template>
      </template>
    </div>

    <ModalCreateCampaign @close="closeModal('newCampaign')" v-if="isModalActive('newCampaign')" @create="createCampaign" />
    <ModalSelectPage @close="closeModal('selectPage')" v-if="isModalActive('selectPage')" @select="createNewCampaign" :btnStatus.sync="btnStatus" />
  </article>
</template>

<script>
/* eslint-disable vue/no-unused-components */
/* eslint-disable no-unused-vars */
import { mapMutations, mapActions, mapState, mapGetters } from "vuex";
import { actions, mutations } from "@/store/analytic/types.js";

import GpTabs, { GpTab, GpTabsNav } from "@/core/shared/GpTabs";
import GpList, { GpListItem, GpListLoading } from "@/core/shared/GpList";
import { GpInputSearch } from "@/core/shared/GpForms";
import GpEmptyPage from "@/core/shared/GpEmptyPage";
import Pagination from "@/core/shared/essenstials/Pagination";
import FilterSelect from "@/modules/Dashboard/components/FilterSelect.vue";

import { ButtonCreateCampaign, FilterCampaign, CampaignItem, ModalSelectPage, ModalCreateCampaign } from "../components";
import processButton from "@/mixins/processButton.js";
import errorHandle from "@/mixins/errorHandle.js";
import routeGuard from "@/mixins/routeGuard";
import dynamicTriggerContent from "@/mixins/dynamicTriggerContent";
import { PLAN_NO } from "../../../contants/plan";

export default {
  name: "ABTesting",
  components: {
    GpTabs,
    GpTabsNav,
    GpTab,
    CampaignItem,
    FilterSelect,
    GpInputSearch,
    GpList,
    GpListItem,
    GpListLoading,
    ButtonCreateCampaign,
    ModalCreateCampaign,
    ModalSelectPage,
    Pagination
  },
  mixins: [processButton(), errorHandle(), routeGuard("analytics"), dynamicTriggerContent()],
  data() {
    return {
      active: "all",
      campaign: null,
      filter: "modified",
      query: "",
      fetched: false,

      modals: {
        newCampaign: {
          active: false,
          name: "",
          alertText: ""
        },
        selectPage: {
          active: false,
          name: "",
          alertText: ""
        }
      },
      page: 1
    };
  },
  computed: {
    ...mapState({
      shopInfo: state => state.account.shopInfo,
      loading: state => state.analytic.loading,
      allCampaigns: state => state.analytic.campaigns.list,
      totalCampaigns: state => state.analytic.campaigns.total,
      permission: state => state.account.permissions,
      planLimitation: state => state.account.shopInfo?.planLimitation
    }),
    ...mapGetters("analytic", {
      campaigns: "categoriedCampaigns"
    }),
    ...mapState("account", {
      shopInfo: "shopInfo"
    }),
    campaignList() {
      if (!this.campaigns) return [];
      let tab = this.active == "" ? "all" : this.active;
      return this.campaigns[tab] || [];
    },
    sortedList() {
      let arr = JSON.parse(JSON.stringify(this.campaignList));
      let sorter = null;
      switch (this.filter) {
        case "modified": {
          sorter = (a, b) => {
            let valueA = new Date(a.updated_at);
            let valueB = new Date(b.updated_at);
            return valueB - valueA;
          };
          break;
        }
        case "created": {
          sorter = (a, b) => {
            let valueA = new Date(a.created_at);
            let valueB = new Date(b.created_at);
            return valueB - valueA;
          };
          break;
        }
        default: {
          sorter = (a, b) => {
            if ((a.name || "").toLowerCase() > (b.name || "").toLowerCase()) return 1;
            if ((a.name || "").toLowerCase() < (b.name || "").toLowerCase()) return -1;
            return 0;
          };
          break;
        }
      }
      arr.sort(sorter);
      return arr;
    },
    filterOptions() {
      return [
        {
          value: "az",
          text: this.$t("page.sort.name", { order: this.$t("page.sort.az") })
        },
        {
          value: "modified",
          text: this.$t("page.sort.modified")
        },
        {
          value: "created",
          text: this.$t("page.sort.created")
        }
      ];
    },
    filteredList() {
      return this.sortedList.filter(item => {
        let iTitle = (item.name || "").toLowerCase();
        let q = this.query.toLowerCase();
        return iTitle.indexOf(q) > -1;
      });
    },
    slicedList() {
      let start = (this.page - 1) * this.paging.limit;
      let end = this.page * this.paging.limit;
      const output = this.filteredList.slice(start, end);
      return output;
    },
    closePortal() {
      // return !this.campaigns || !this.campaigns.opens || !this.campaigns.opens.length;
      return this.campaignList && this.campaignList.length;
    },
    campaignTypeText() {
      const value = this.active;
      switch (value) {
        case "on_hold":
          return this.$t("analytic.ab.onHold");
        case "running":
          return this.$t("analytic.ab.running");
        case "completed":
          return this.$t("analytic.ab.completed");
        default:
          return "";
      }
    },
    reachLimit() {
      let limit = 2;

      // const planLimit = {
      //   advanced: 20,
      //   trial: 0,
      //   build: 1,
      //   optimize: 20,
      //   enterprise: "unlimited"
      // };

      const count = this.allCampaigns.length || 0;

      if (this.shopInfo.plan === PLAN_NO.ENTERPRISE) {
        return true;
      } else {
        const activePlan = this.shopInfo?.developmentStore ? this.shopInfo?.planDevelopmentStore : this.shopInfo.plan;
        if (this.planLimitation && this.planLimitation[activePlan]) {
          const { conversionOptimization } = this.planLimitation[activePlan];
          limit = conversionOptimization?.abTesting?.nbOfCampaign || 2;
        }
      }
    
      return count < limit;
    },
    paging() {
      const limit = 5;
      return {
        limit,
        page: this.page,
        total: Math.ceil(this.filteredList.length / limit)
      };
    }
  },
  watch: {},
  created() {
    const { shopInfo } = this;
    const { params } = this.$route;
    const { shopifyDomain } = shopInfo;
    this.fetchAnalytic({ domain: shopifyDomain }).then(() => {
      this.fetched = true;
    });
    if (params && params.status) {
      this.active = params.status;
    }
  },
  methods: {
    ...mapMutations("analytic", {
      attachCampaign: mutations.ANALYTIC_ATTACH
    }),
    ...mapActions("analytic", {
      doCreateCampaign: actions.CREATE_NEW_CAMPAIGN_ANALYTIC,
      fetchAnalytic: actions.FETCH_ANALYTIC
    }),
    toPage(p) {
      this.page = p;
    },
    resetPaging() {
      this.page = 1;
    },
    changeTab(index) {
      this.active = index;
      let queryType = index;
      const querries = {};
      if (index != "all") {
        querries.type = index;
      }
      this.$router.push({
        name: "ABTesting",
        query: querries
      });
    },
    itemClick(item) {
      this.attachCampaign(item);
      this.$router.push({
        name: "CampaignDetail",
        params: { id: item.id }
      });
    },

    // NEW FUNCTIONS

    closeModal(type) {
      this.alertText = "";
      this.modals[type].active = false;
      this.resetStatus();
    },
    isModalActive(type) {
      return this.modals[type].active;
    },
    openModal(type) {
      this.modals[type].active = true;
    },

    createCampaign(name) {
      this.modals.newCampaign.name = name;
      this.closeModal("newCampaign");
      this.openModal("selectPage");
    },

    createNewCampaign(pageIDs, pType) {
      let percent = 1 / (pageIDs.length || 1);
      const pages = pageIDs.map((id, index) => {
        let item = {
          gID: id,
          percent: percent
        };
        if (index == 0) {
          item.isMainPage = true;
        }
        return item;
      });
      this.gSnackbarCommit({
        message: this.$t("status.processing"),
        type: "loading"
      });
      this.activeLoading();
      this.doCreateCampaign({
        pageType: pType,
        name: this.modals.newCampaign.name,
        duration: 7,
        pages
      })
        .then(res => {
          this.gSnackbarCommit({
            message: this.$t("status.success"),
            type: "success"
          });
          const id = res.campaign && res.campaign.id;
          if (id != undefined) {
            this.attachCampaign(res.campaign);
            this.$router.push({ name: "CampaignDetail", params: { id } });
          }
          this.closeModal("selectPage");
          this.activeSuccess();
          this.currentTabIndex = 1;
        })
        .catch(err => {
          this.gSnackbarCommit({
            message: this.getErrorMessage(err),
            type: "error"
          });
          this.activeError();
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.gp-tabs {
  &:not(.verticle) &-nav {
    &:after {
      display: none;
    }
  }
}
.empty-campaign {
  padding-top: 196px;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
}

.gp-campaigns {
  .gp-tabs {
    .gp-tabs-nav {
      &.no-min-height {
        min-height: unset;
      }
      .gp-tabs-nav-item {
        white-space: nowrap;
        &:not(:last-child) {
          margin-right: 32px;
        }
      }

      // .btn {
      // }
    }
  }
  .warning-container {
    background: rgba(255, 187, 28, 0.5);
    border-radius: $radius;
  }
  @media (max-width: 767px) {
    .gp-tabs {
      .gp-tabs-nav {
        flex-direction: row !important;
        border-left: none;
        // border-bottom: 1px solid $grey3;
        .gp-tabs-nav-item {
          border-bottom: 1px solid $grey3;
          margin-right: 0px;
          // padding-right: 32px;
          // text-align: center;
          display: flex;
          justify-content: center;
          flex: 1;
          border-radius: inherit !important;

          &:before {
            bottom: 0;
            right: 0;
            left: 0 !important;
            width: 100% !important;
            height: 2px;
            top: auto;
          }
          // &:active {
          // }
        }
      }
    }
    .campaign-list-item {
      min-height: 60px;
    }

    // .badge {
    //   left: inherit !important;
    //   right: 8px;
    // }
  }

  @media (max-width: 575px) {
    .gp-tabs {
      .gp-tabs-nav {
        .gp-tabs-nav-item {
          margin-right: 0;
          padding-left: 10px;
          padding-right: 10px;
        }
        .btn {
          padding: 6px;
        }
      }
    }
  }

  // .badge {
  //   position: absolute;
  //   padding: 0px 5px;
  //   top: calc(50% - 8px);
  //   left: calc(100% + 4px);
  //   min-height: 16px;
  //   min-width: 16px;
  //   @include flex-center("omit");

  //   &-green {
  //     background: $cGreen;
  //     color: $neutral5;
  //   }
  // }
}
</style>
